export default "__VITE_ASSET__DHEi7Uig__"